import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Grid2, IconButton, MenuItem, Paper, Select, Snackbar, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, TextField, Typography } from "@mui/material";
import TokenError from "../tokenError";
import config from '../../config/config.js';
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import prevIcon from '../../assets/icons/left-arrow.svg';
import nextIcon from '../../assets/icons/right-arrow.svg';
import {makeGetRequestToUrl, makePostRequestToUrl} from '../commonFunc.jsx';
import { Label } from "flowbite-react";
import CloseIcon from '@mui/icons-material/Close';
import InfoIcon from '@mui/icons-material/Info';
import uploadBlue from '../../assets/icons/UploadBlue.svg';
import axios from "axios";

const DriverSubscription = () => {
    const navigate = useNavigate();
    const [tokenExpired, setTokenExpired] = useState(false);
    const [rows, setRows] = useState([]);
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const cities = JSON.parse(localStorage.getItem('cities'));
    const [cityFilter, setCityFilter] = useState(cities[0].city_id);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('request_id');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [open, setOpen] = useState(false);
    const [editable, setEditable] = useState(false);
    const [planId, setPlanId] = useState(0);
    const [planName, setPlanName] = useState('');
    const [rideLimit, setRideLimit] = useState('');
    const [perRideMaxDistance, setPerRideMaxDistance] = useState('');
    const [totalFareCapping, setTotalFareCapping] = useState('');
    const [validity, setValidity] = useState('');
    const [price, setPrice] = useState('');
    const [taxPercentage, setTaxPercentage] = useState('');
    const [tnc, setTnc] = useState('');
    const [isActive, setIsActive] = useState(1);
    const [editingRowData, setEditingRowData] = useState(null);
    const [openCancelConfirmModal, setOpenCancelConfirmModal] = useState(false);
    const [planIcon, setPlanIcon] = useState('');
    const [isRecommended, setIsRecommended] = useState(0);
    const [planBenefits, setPlanBenefits] = useState([]);
    const [recommendedPlanId, setRecommendedPlanId] = useState(0);

    const handleCityChange = (e) =>{
        const city =  cities.find((cityObj) => cityObj.city_id === e)
        setCityFilter(e);
    }

    // Ensure rows is an array and calculate the number of pages safely
    const rowArray = Array.isArray(rows) ? rows : [];
    const totalEntries = rowArray.length;
    const totalPages = Math.ceil(totalEntries / rowsPerPage);
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    //sorting
    const handleRequestSort = (property) => {
        const isAscending = orderBy === property && order === 'asc';
        setOrder(isAscending ? 'desc' : 'asc');
        setOrderBy(property);
        const sortedRows = [...rows].sort((a, b) => {
            if (a[property] < b[property]) return isAscending ? -1 : 1;
            if (a[property] > b[property]) return isAscending ? 1 : -1;
            return 0;
        });
        setRows(sortedRows);
    };

    const fetchDriverSubscriptions = async() => {
        let recommended=0;
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/driver/fetch_driver_subscription';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setRows(response.data);
                response.data.forEach(element => {
                    if(element.is_recommend==1 && element.is_active==1){
                        recommended=element.plan_id;
                    }
                });
                setRecommendedPlanId(recommended);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }

    useEffect(() => {
        fetchDriverSubscriptions();
    }, [cityFilter]);

    // Shared handlers to prevent negative input in number fields
    const preventNegativeKey = (e) => {
        if (e.key === '-' || e.key === 'e' || e.key === 'E' || e.key === '+') {
            e.preventDefault();
        }
    };

    // Handler to enforce non-negative numbers with max 3 decimal places
    const handleNonNegativeWithMaxDecimals = (setter, maxDecimals = 3) => (e) => {
        let value = e.target.value;
        if (value === '') {
            setter('');
            return;
        }
        // Coerce to string and normalize negative sign
        if (value.startsWith('-')) value = value.slice(1);
        // Trim decimal places if present
        if (value.includes('.')) {
            const [intPart, decPartRaw] = value.split('.');
            const decPart = decPartRaw.slice(0, maxDecimals);
            value = decPart.length > 0 ? `${intPart}.${decPart}` : intPart;
        }
        // Validate numeric
        const n = Number(value);
        if (Number.isNaN(n)) return;
        setter(value);
    };

    // Plan benefits handlers
    const addBenefit = () => {
        setPlanBenefits(prev => [...prev, '']);
    };
    const removeBenefit = (index) => {
        setPlanBenefits(prev => prev.filter((_, i) => i !== index));
    };
    const updateBenefit = (index, value) => {
        setPlanBenefits(prev => prev.map((b, i) => i === index ? value : b));
    };

    const handleNonNegative = (setter) => (e) => {
        const value = e.target.value;
        if (value === '') {
            setter('');
            return;
        }
        const n = Number(value);
        if (Number.isNaN(n)) {
            return;
        }
        setter(n < 0 ? String(Math.abs(n)) : value);
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        showSnackbar(false); 
    };

    const handleOpenAddSubscription = () => {
        setOpen(true);
        setEditable(false);
        setPlanId('');
        setPlanName('');
        setRideLimit('');
        setPerRideMaxDistance('');
        setTotalFareCapping('');
        setValidity('');
        setPlanIcon('');
        setPrice('');
        setIsRecommended(0);
        setTaxPercentage('');
        setTnc('');
        setIsActive(1);
        setPlanBenefits(['']);
    }

    const handleOpenEditSubscription = (row) => {
        setEditingRowData(row);
        setPlanId(row.plan_id);
        setPlanName(row.plan_name);
        setRideLimit(row.ride_limit);
        setPerRideMaxDistance(row.per_ride_max_distance);
        setTotalFareCapping(row.total_fare_capping);
        setValidity(row.validity);
        setPrice(row.price);
        setTaxPercentage(row.tax_percentage);
        setTnc(row.t_n_c);
        setIsActive(row.is_active);
        setPlanIcon(row.plan_icon);
        setIsRecommended(row.is_recommend);
        setPlanBenefits(Array.isArray(row.plan_benefits) ? row.plan_benefits : (row.plan_benefits ? [String(row.plan_benefits)] : ['']));
        setOpen(true);
        setEditable(true);
    }

    const handleClose = () => {
        setOpen(false);
        setEditable(false);
    }

    const handleSubmit = async() => {
        const token = localStorage.getItem('token');
        const payload={
            token: token,
            city_id: cityFilter,
            is_recommend: isRecommended ==true ? 1 : 0,
            // plan_name: planName,
        }
        if(planName==""){
            setMessage('Please enter plan name.');
            showSnackbar(true);
            return;
        }
        if(rideLimit==""){
            setMessage('Please enter ride limit.');
            showSnackbar(true);
            return;
        }
        if(perRideMaxDistance==""){
            setMessage('Please enter distance limit.');
            showSnackbar(true);
            return;
        }
        if(totalFareCapping==""){
            setMessage('Please enter max ride fare threshold.');
            showSnackbar(true);
            return;
        }
        if(validity==""){
            setMessage('Please enter validity.');
            showSnackbar(true);
            return;
        }
        if(price==""){
            setMessage('Please enter subscription price.');
            showSnackbar(true);
            return;
        }
        const cleanedBenefits = (planBenefits || []).map(b => (b ?? '').trim()).filter(b => b !== '');
        if(cleanedBenefits.length === 0){
            setMessage('Please add at least one plan benefit.');
            showSnackbar(true);
            return;
        }
        if(planId!='' && editable){
            payload.plan_id = planId;
            if(editingRowData.plan_name != planName) payload.plan_name=planName;
            if(editingRowData.ride_limit != rideLimit) payload.ride_limit=rideLimit;
            if(editingRowData.per_ride_max_distance != perRideMaxDistance) payload.per_ride_max_distance=perRideMaxDistance;
            if(editingRowData.total_fare_capping != totalFareCapping) payload.total_fare_capping=totalFareCapping;
            if(editingRowData.validity != validity) payload.validity=validity;
            if(editingRowData.price != price) payload.price=price;
            if(editingRowData.tax_percentage != taxPercentage) payload.tax_percentage=taxPercentage;
            if(editingRowData.t_n_c != tnc) payload.t_n_c=tnc;
            if(editingRowData.is_active != isActive) payload.is_active=isActive;
            if(editingRowData.plan_icon != planIcon) payload.plan_icon=planIcon;
            if(JSON.stringify(editingRowData.plan_benefits || []) !== JSON.stringify(cleanedBenefits)) payload.plan_benefits = cleanedBenefits;
        }
        else{
            payload.plan_name = planName;
            payload.ride_limit = rideLimit;
            payload.per_ride_max_distance = perRideMaxDistance;
            payload.total_fare_capping = totalFareCapping;
            payload.validity = validity;
            payload.price = price;
            payload.is_active = isActive == 1 ? 1 : 0
            payload.plan_benefits = cleanedBenefits;
            if(planIcon){
                payload.plan_icon=planIcon;
            }
            if(taxPercentage){
                payload.tax_percentage=taxPercentage;
            }
            if(tnc){
                payload.t_n_c=tnc;
            }
        }
        try {
            const url = operationsUrl + '/driver/add_update_driver_subscription';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);
                handleClose();
                fetchDriverSubscriptions();
            } else {
                setMessage(response.message)
                showSnackbar(true);
            }

        } catch (error) {
            setMessage(error);
        }
    }

    const setEnabled = async(id, val) => {
        // console.log('id= ', id, 'and val= ', val);
        try {
            const token = localStorage.getItem('token');
            const body = {
                token: token,
                // name: name,
                is_active: val,
                city_id: cityFilter,
                is_recommend: 0,
                plan_id: id
            };

            const response = await fetch(operationsUrl + '/driver/add_update_driver_subscription', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
            });
            const data = await response.json();

            if (data.flag==200) {
                fetchDriverSubscriptions();
                setMessage(data.message);
                showSnackbar(true);
                setOpenCancelConfirmModal(false);
            }
            else{
                setMessage(data.message);
                showSnackbar(true);
            }
        } catch (error) {
            console.log('An error occurred. Please try again later.');
        }
    }

    const handleFileChange = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        // Validate image dimensions (must be between 30-40 px in both width and height)
        const img = new Image();
        const objectUrl = URL.createObjectURL(file);
        try {
            await new Promise((resolve, reject) => {
                img.onload = () => resolve();
                img.onerror = reject;
                img.src = objectUrl;
            });
            const validW = img.width >= 30 && img.width <= 40;
            const validH = img.height >= 30 && img.height <= 40;
            if (!validW || !validH) {
                setMessage('Please upload an icon with the given size.');
                showSnackbar(true);
                event.target.value = '';
                return;
            }
        } finally {
            URL.revokeObjectURL(objectUrl);
        }

        const formData = new FormData();
        formData.append('image', file);

        try {
            const response = await axios.post(operationsUrl + '/upload_image', formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            const s3Url = response.data.url;
            setPlanIcon(s3Url);
        } catch (error) {
            console.error('Error uploading image:', error);
        }
    };

    return (
        <div>
            {tokenExpired && (<TokenError/>)}
            
            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>
                Manage Driver Subscription Plan
            </Typography>

            {/* Filters */}
            <Grid2 item container spacing={2} alignItems="center" sx={{ marginTop: '1%', marginBottom: '2%' }}>
                <Grid2 item>
                    <Select value={cityFilter} 
                    onChange={(e) => handleCityChange(e.target.value)} displayEmpty
                    style={{width: '190px',height:'46px', marginTop:'0px',borderRadius:'8px',backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF'}}>
                        <MenuItem value="">Select City</MenuItem>
                        {cities.map((city) => (
                            <MenuItem key={city.city_name} value={city.city_id}>
                                {city.city_name}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid2>
                <Grid2 item sx={{marginLeft:'auto'}}>
                    <Button
                        variant="contained" 
                        onClick={handleOpenAddSubscription}
                        style={{width:'185px',height: '46px',backgroundColor:'#0065ff',textTransform:'none',borderRadius:'8px'}}>
                        + Add Subscription
                    </Button>
                </Grid2>
            </Grid2>

            <TableContainer className="table-container" sx={{maxHeight:'72vh'}}>
                <Table stickyHeader className="scrollable-table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" className="table-header" style={{ width: '15%', minWidth:'80px' }}>
                                <TableSortLabel active={orderBy === 'plan_id'} direction={orderBy === 'plan_id' ? order : 'asc'}
                                    onClick={() => handleRequestSort('plan_id')}>
                                Plan ID
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%', minWidth:'120px' }}>Plan Name</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%', minWidth:'80px' }}>Plan Icon</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%', minWidth:'80px' }}>
                                <TableSortLabel active={orderBy === 'ride_limit'} direction={orderBy === 'ride_limit' ? order : 'asc'}
                                    onClick={() => handleRequestSort('ride_limit')}>
                                Ride Limit
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%', minWidth:'80px' }}>
                                <TableSortLabel active={orderBy === 'per_ride_max_distance'} direction={orderBy === 'per_ride_max_distance' ? order : 'asc'}
                                    onClick={() => handleRequestSort('per_ride_max_distance')}>
                                Max Distance Per Ride (in km)
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%', minWidth:'80px' }}>
                                <TableSortLabel active={orderBy === 'total_fare_capping'} direction={orderBy === 'total_fare_capping' ? order : 'asc'}
                                    onClick={() => handleRequestSort('total_fare_capping')}>
                                Max Fare
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%', minWidth:'80px' }}>
                                <TableSortLabel active={orderBy === 'validity'} direction={orderBy === 'validity' ? order : 'asc'}
                                    onClick={() => handleRequestSort('validity')}>
                                Validity
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%', minWidth:'80px' }}>
                                <TableSortLabel active={orderBy === 'price'} direction={orderBy === 'price' ? order : 'asc'}
                                    onClick={() => handleRequestSort('price')}>
                                Price
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%', minWidth:'80px' }}>
                                <TableSortLabel active={orderBy === 'tax_percentage'} direction={orderBy === 'tax_percentage' ? order : 'asc'}
                                    onClick={() => handleRequestSort('tax_percentage')}>
                                Tax Percentage
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%', minWidth:'200px', maxWidth:'200px' }}>Plan Benefits</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%', minWidth:'80px' }}>
                                <TableSortLabel active={orderBy === 'is_recommend'} direction={orderBy === 'is_recommend' ? order : 'asc'}
                                    onClick={() => handleRequestSort('is_recommend')}>
                                Recommended
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%', minWidth:'200px', maxWidth:'200px' }}>
                                <TableSortLabel active={orderBy === 't_n_c'} direction={orderBy === 't_n_c' ? order : 'asc'}
                                    onClick={() => handleRequestSort('t_n_c')}>
                                Terms and Conditions
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%', minWidth:'80px' }}>Status</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%', minWidth:'80px' }}>Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.length === 0 && (
                            <TableRow>
                            <TableCell colSpan={24} align="center">
                                <Typography variant="body1">No data found</Typography>
                            </TableCell>
                            </TableRow>
                        )}
                        {rows
                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((row) => (
                            <TableRow key={row.plan_id}>
                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.plan_id}</Typography></TableCell>
                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.plan_name}</Typography></TableCell>
                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>
                                    {row.plan_icon ?
                                        <img src={row.plan_icon} alt="" style={{ width: '48px', height: '48px', border:'1px solid #D1D5DB', borderRadius:'8px', boxShadow:'none' }} />
                                        : '--'}
                                </Typography></TableCell>
                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.ride_limit}</Typography></TableCell>
                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.per_ride_max_distance}</Typography></TableCell>
                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.total_fare_capping}</Typography></TableCell>
                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.validity}</Typography></TableCell>
                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.price}</Typography></TableCell>
                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.tax_percentage ? row.tax_percentage : '--'}</Typography></TableCell>
                                <TableCell align="center" sx={{ width: 200, maxWidth: 200, whiteSpace: 'normal', wordBreak: 'break-word' }}>
                                    {Array.isArray(row.plan_benefits) ? (
                                        <ul style={{ margin: 0, paddingLeft: 16, textAlign: 'center', wordBreak: 'break-word' }}>
                                            {row.plan_benefits.map((b, i, arr) => (
                                                <>
                                                    <li key={`benefit-${i}`} style={{ listStyleType: 'disc', marginTop:'4px' }}>{b}</li>
                                                    {i < arr.length - 1 && (
                                                        <hr style={{border: 'none', borderTop: '2px dotted #D1D5DB'}} />
                                                    )}
                                                </>
                                            ))}
                                        </ul>
                                    ) : row.plan_benefits ? (
                                        <ul style={{ margin: 0, paddingLeft: 16, textAlign: 'center', wordBreak: 'break-word' }}>
                                            {String(row.plan_benefits).split(',').map((b, i, arr) => (
                                                <>
                                                    <li key={`benefit-str-${i}`} style={{ listStyleType: 'disc', marginTop:'4px' }}>{b.trim()}</li>
                                                    {i < arr.length - 1 && (
                                                        <hr style={{border: 'none', borderTop: '2px dotted #D1D5DB'}} />
                                                    )}
                                                </>
                                            ))}
                                        </ul>
                                    ) : (
                                        <Typography sx={{ width: 'auto', minWidth: '100px' }}>--</Typography>
                                    )}
                                </TableCell>
                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', color:row.is_recommend==1?'green':'#9E9E9E' }}>{row.is_recommend==1?'Yes':'No'}</Typography></TableCell>
                                <TableCell align="center" sx={{ width: 200, maxWidth: 200, whiteSpace: 'normal', wordBreak: 'break-word' }}>
                                    <Typography sx={{ width: '100%', wordBreak: 'break-word' }}>{row.t_n_c || '--'}</Typography>
                                </TableCell>
                                <TableCell align="center">
                                    <div style={{ display: 'flex', justifyContent:'center'}}>
                                        <Button variant="contained" onClick={() => setEnabled(row.plan_id,1)}
                                            style={{
                                                backgroundColor: row.is_active ? '#0DBA78' : '#F4F4F4', minWidth: '80px',padding: '6px 16px',
                                                color:row.is_active?'#FFFFFF':'#9E9E9E',textTransform:'none',borderRadius:'8px 0 0 8px', boxShadow: 'none',
                                            }}
                                        >
                                            Activate
                                        </Button>
                                        <Button variant="contained" onClick={() => setEnabled(row.plan_id, 0)}
                                            style={{
                                                backgroundColor: !row.is_active ? '#D14545' : '#F4F4F4', color: !row.is_active ? '#FFFFFF' : '#9E9E9E',
                                                textTransform:'none', borderRadius:'0 8px 8px 0', boxShadow:'none',padding:'6px 16px', minWidth:'80px',
                                            }}
                                        >
                                            Deactivate
                                        </Button>
                                    </div>
                                </TableCell>
                                <TableCell align="center">
                                    <Grid2 sx={{display:'flex'}}>
                                        <Button
                                            variant="contained"
                                            onClick={() => handleOpenEditSubscription(row)}
                                            sx={{
                                                backgroundColor: '#EFFBF7', color: '#0DBA78', border: '1px solid #0DBA78', textTransform: 'none',
                                                borderRadius: '8px', minWidth:'40px', boxShadow:'none', width:"90px",
                                                '&:hover': {backgroundColor: '#0DBA78', color: 'white'},
                                                '&:active': { backgroundColor: '#0DBA78', color: 'white'}
                                            }}>
                                            
                                            <Typography sx={{marginRight:'6%'}}>Edit</Typography>
                                            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.84304 9.45074L5.39054 6.89324C5.47025 6.53784 5.64979 6.21258 5.90804 5.95574L10.9105 0.998238C11.4178 0.481469 12.1066 0.182825 12.8305 0.165738C13.3765 0.157914 13.9031 0.368518 14.293 0.750738C15.1452 1.75759 15.0352 3.26115 14.0455 4.13324L9.04304 9.13574C8.7862 9.39399 8.46095 9.57353 8.10554 9.65324L5.54804 10.2007H5.40554C5.21858 10.2079 5.04 10.1228 4.92774 9.97316C4.81547 9.82347 4.78382 9.62822 4.84304 9.45074ZM6.70304 6.75824C6.59796 6.86007 6.52496 6.99043 6.49304 7.13324L6.12554 8.88074L7.87304 8.50574C8.01585 8.47382 8.14621 8.40082 8.24804 8.29574L13.2505 3.29324C13.7986 2.85451 13.9073 2.0636 13.498 1.49324C13.3188 1.32202 13.0783 1.23012 12.8305 1.23824C12.4035 1.25539 11.9999 1.43834 11.7055 1.74824L6.70304 6.75824Z" fill="currentColor"/>
                                                <path d="M13.933 6.19574C13.6241 6.19978 13.3746 6.44927 13.3705 6.75824V11.0257C13.3806 11.6289 13.148 12.2109 12.7249 12.641C12.3019 13.0711 11.7238 13.3133 11.1205 13.3132H3.97305C2.72607 13.2888 1.72688 12.2729 1.72305 11.0257V3.90824C1.74352 2.65955 2.7617 1.65807 4.01055 1.65824H8.27805C8.58871 1.65824 8.84055 1.4064 8.84055 1.09574C8.84055 0.785078 8.58871 0.533238 8.27805 0.533238H3.97305C2.10292 0.533125 0.581098 2.03823 0.560547 3.90824V11.0257C0.560547 12.9104 2.08838 14.4382 3.97305 14.4382H11.0905C12.9723 14.4341 14.4956 12.9075 14.4955 11.0257V6.75824C14.4915 6.44927 14.242 6.19978 13.933 6.19574Z" fill="currentColor"/>
                                            </svg>
                                        </Button>

                                        <Button sx={{border:'1px solid #C71F1F', width:'90px',borderRadius: '8px', minWidth:'40px', boxShadow:'none', marginLeft:'8px', color:'#C71F1F',
                                            '&:hover': {backgroundColor: '#C71F1F', color: 'white'},
                                            '&:active': { backgroundColor: '#C71F1F', color: 'white'}
                                            }} 
                                            onClick={() => {
                                                setOpenCancelConfirmModal(true);
                                                setPlanId(row.plan_id)
                                            }}
                                        >
                                            <Typography sx={{textTransform:'none'}}>Delete</Typography>
                                        </Button>
                                    </Grid2>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>

                <div className="custom-pagination">
                    <div className="pagination-info">
                        {`Showing ${page * rowsPerPage + 1} to ${Math.min(
                            (page + 1) * rowsPerPage,
                            rows.length
                        )} of ${rows.length} entries`}
                    </div>
                    <div className="pagination-controls">
                    <button
                        onClick={() => handleChangePage(null, page - 1)}
                        disabled={page === 0}
                        className="pagination-arrow"
                    >
                        <img src={prevIcon} alt="Previous" />
                    </button>
                        <div className="pagination-numbers">
                            {[...Array(Math.ceil(rows.length / rowsPerPage))].map((_, index) => (
                                <button key={index} onClick={() => handleChangePage(null, index)}
                                    className={`pagination-number ${ page === index ? 'active' : ''}`}>
                                    {index + 1}
                                </button>
                            ))}
                        </div>
                        <button
                            onClick={() => handleChangePage(null, page + 1)}
                            disabled={page >= Math.ceil(rows.length / rowsPerPage) - 1}
                            className="pagination-arrow"
                        >
                            <img src={nextIcon} alt="Next" />
                        </button>
                    </div>
                </div>
            </TableContainer>

            {open && (
                <div 
                    style={{position: 'fixed',top: 65, right:0, height: '100%',width: '50%',backgroundColor: '#f9f9f9',
                        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',transition: 'right 0.3s ease-in-out',
                        zIndex: 1000,overflowY: 'auto',padding: 20
                    }}>
                    <Box>
                        <div style={{ position: 'relative', padding: '40px 0' }}>
                            <IconButton aria-label="close" onClick={handleClose}
                                style={{
                                    position: 'absolute',top: '-15px',left: '1px',color: '#333',zIndex: 10}}>
                                <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
                            </IconButton>
                            <Paper elevation={3}
                                style={{ padding: '30px', maxWidth: '800px', margin: '0 auto',
                                    backgroundColor: '#FFFFFF', borderRadius: '12px'}}>
                                
                                <Grid2 sx={{display:'flex', alignItems:'center'}}>
                                    <Typography variant="h6" style={{ marginBottom: '8px', marginTop: '8px', fontWeight: 'bold' }}>
                                        {editable ? 'Edit Subscription' : 'Add Subscription'}
                                    </Typography>
                                    <Grid2 sx={{border: isRecommended ? '1px solid #0DBA78' : '1px solid #E3E5E8', borderRadius:'20px', padding:'2px 6px', marginLeft:'auto', display:'flex', alignItems:'center', backgroundColor:isRecommended ? '#EFFBF7' : '#F6F6F6'}}>
                                        <Typography sx={{color: isRecommended ? '#0DBA78' : '#9FA3A7'}}>Recommended</Typography>
                                        <Switch sx={{color:'#0DBA78'}}
                                            checked={isRecommended}
                                            onChange={(e) => {
                                                const next = e.target.checked;
                                                const anotherAlready = recommendedPlanId !== 0 && (editable ? planId !== recommendedPlanId : true);
                                                if (next && anotherAlready) {
                                                    setMessage("Plan id '" + recommendedPlanId + "' is already set as recommended.");
                                                    showSnackbar(true);
                                                    return;
                                                }
                                                setIsRecommended(next)
                                            }}
                                        />
                                    </Grid2>
                                </Grid2>

                                <Grid container spacing={2} sx={{marginTop:'1%'}}>
                                    <Grid item xs={12} sm={6}>
                                        <Label>Subscription Name<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField  sx={{marginTop:'1%'}}
                                            placeholder="Title" fullWidth variant="outlined" type="text" value={planName}
                                            onChange={(e) => setPlanName(e.target.value)}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF', borderRadius:'8px'}
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Label>Upload Plan Icon<span style={{color :'#B6BCBC'}}>(Size should be 36x36 px)</span></Label>
                                        <Grid2
                                            sx={{
                                                border: '1px dotted #D1D5DB',
                                                marginTop: '1%',padding: planIcon ? '2%' : '4%',
                                                borderRadius: '8px',display: 'flex',
                                                alignItems: 'center', gap: '8px'
                                            }}
                                        >
                                            <input
                                                type="file"
                                                accept="image/*"
                                                onChange={handleFileChange}
                                                style={{
                                                display: 'none', // hide the native file input completely
                                                }}
                                                id="upload-button"
                                            />
                                            
                                            <label htmlFor="upload-button" style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <img src={uploadBlue} alt="Upload Icon" style={{ width: '24px', height: '24px' }} />
                                                <span style={{ color: '#9FA3A7', fontWeight: 500 }}>Upload Icon</span>
                                                {planIcon && <img src={planIcon} alt="" style={{ width: '36px', height: '36px', border:'1px solid #D1D5DB', borderRadius:'8px' }} />}
                                            </label>
                                        </Grid2>

                                    </Grid>

                                    <Grid item xs={12} sm={12}>
                                        <Label>Subscription Price<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField  sx={{marginTop:'1%'}}
                                            placeholder="Price" fullWidth variant="outlined" type="number" value={price}
                                            onChange={handleNonNegativeWithMaxDecimals(setPrice)}
                                            onKeyDown={preventNegativeKey}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF', borderRadius:'8px'}
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={12}>
                                        <Label>Tax Applicable on Subscription Cost</Label>
                                        <TextField  sx={{marginTop:'1%'}}
                                            placeholder="Maximum Discount" fullWidth variant="outlined" type="number" value={taxPercentage}
                                            onChange={handleNonNegativeWithMaxDecimals(setTaxPercentage)}
                                            onKeyDown={preventNegativeKey}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF', borderRadius:'8px'}
                                            }}
                                        />
                                        {taxPercentage && 
                                            <Grid item container sx={{backgroundColor:'#FFF1CB', marginTop:'8px', alignItems:'center', borderRadius:'8px', padding:'4px'}}>
                                                <InfoIcon sx={{color:'#2A313C', fontSize:'16px',paddingLeft:'4px'}} />
                                                <Typography sx={{ color:'#2A313C', fontSize:'14px', marginLeft:'4px'}}>{taxPercentage}% tax will be applicable on the subscription plan</Typography>
                                            </Grid>
                                        }
                                        </Grid>

                                    <Grid item xs={12} sm={12}>
                                        <Label>Ride Limit<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField  sx={{marginTop:'1%'}}
                                            placeholder="Ride Limit" fullWidth variant="outlined" type="number" value={rideLimit}
                                            onChange={handleNonNegative(setRideLimit)}
                                            onKeyDown={preventNegativeKey}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF', borderRadius:'8px'}
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={12}>
                                        <Label>Validity<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField  sx={{marginTop:'1%'}}
                                            placeholder="Validity (in days)" fullWidth variant="outlined" type="number" value={validity}
                                            onChange={handleNonNegative(setValidity)}
                                            onKeyDown={preventNegativeKey}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF', borderRadius:'8px'}
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={12}>
                                        <Grid sx={{backgroundColor:'#F9F9F9', border:'1px solid #CCCDCE', borderRadius:'12px', padding:'16px'}}>
                                            <Typography sx={{fontSize:'18px', fontWeight:'500'}}>Distance Per Ride Limit</Typography>
                                            <Grid item sx={{marginTop:'2%'}}>
                                                <Label>Distance Limit (in km)<span style={{ color: 'red' }}>*</span></Label>
                                                <TextField  sx={{marginTop:'1%'}}
                                                    placeholder="per ride max distance" fullWidth variant="outlined" type="number" value={perRideMaxDistance}
                                                    onChange={handleNonNegativeWithMaxDecimals(setPerRideMaxDistance)}
                                                    onKeyDown={preventNegativeKey}
                                                    InputProps={{
                                                        inputProps: { min: 0 }, // Prevent values less than zero
                                                        style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF', borderRadius:'8px'}
                                                    }}
                                                />
                                                <Grid item container sx={{backgroundColor:'#FFF1CB', marginTop:'8px', alignItems:'center', borderRadius:'8px', padding:'4px'}}>
                                                    <InfoIcon sx={{color:'#2A313C', fontSize:'16px',paddingLeft:'4px'}} />
                                                    <Typography sx={{ color:'#2A313C', fontSize:'14px', marginLeft:'4px'}}>Post distance limit standard percentage based or flat rate commission will be applicable</Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    <Grid item xs={12} sm={12}>
                                        <Label>Max Ride Fare Threshold<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField  sx={{marginTop:'1%'}}
                                            placeholder="Total Fare Capping" fullWidth variant="outlined" type="number" value={totalFareCapping}
                                            onChange={handleNonNegativeWithMaxDecimals(setTotalFareCapping)}
                                            onKeyDown={preventNegativeKey}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF', borderRadius:'8px'}
                                            }}
                                        />
                                        <Grid item container sx={{backgroundColor:'#FFF1CB', marginTop:'8px', alignItems:'center', borderRadius:'8px', padding:'4px'}}>
                                            <InfoIcon sx={{color:'#2A313C', fontSize:'16px',paddingLeft:'4px'}} />
                                            <Typography sx={{ color:'#2A313C', fontSize:'14px', marginLeft:'4px'}}>Post ride limit standard percentage based or flat rate commission structure will be applicable</Typography>
                                        </Grid>
                                    </Grid>

                                    <Grid item xs={12} sm={12}>
                                        <Label>Plan Benefits<span style={{ color: 'red' }}>*</span></Label>
                                        <Grid2 sx={{marginTop:'8px' }}>
                                            {planBenefits.map((benefit, idx) => (
                                                <Grid2 key={idx} container size={12} spacing={2} alignItems="center" sx={{ mb: 1 }}>
                                                    <Grid2 size={1.5}>
                                                        <Typography sx={{ mb: '4px', color:'#2A313C' }}>{`Benefit ${idx + 1}`}</Typography>
                                                    </Grid2>
                                                    <Grid2 size={9.5}>
                                                        <TextField
                                                            placeholder={`Add Benefit ${idx + 1}`}
                                                            fullWidth
                                                            variant="outlined"
                                                            type="text"
                                                            value={benefit}
                                                            onChange={(e) => updateBenefit(idx, e.target.value)}
                                                            inputProps={{
                                                                maxLength: 200,
                                                            }}
                                                            InputProps={{
                                                                style: { height: '46px', fontSize: '16px', backgroundColor: '#FFFFFF', borderRadius: '8px' }
                                                            }}
                                                        />
                                                    </Grid2>
                                                    <Grid2 size={1} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'end', justifyContent: 'center'}}>
                                                        {(planBenefits.length > 1 && (idx !== planBenefits.length - 1)) && (
                                                            <Button
                                                                variant="outlined"
                                                                onClick={() => removeBenefit(idx)}
                                                                sx={{
                                                                    borderColor: '#D14545', color: '#D14545', minWidth: '36px', height: '36px',
                                                                    borderRadius: '8px', padding: 0, lineHeight: 1,
                                                                    '&:hover': { borderColor: '#C71F1F', backgroundColor: 'rgba(199,31,31,0.08)' }
                                                                }}
                                                            >
                                                                X
                                                            </Button>
                                                        )}
                                                        {idx === planBenefits.length - 1 && (
                                                            <Button
                                                                variant="contained"
                                                                onClick={addBenefit}
                                                                disabled = {planBenefits.length >= 6}
                                                                sx={{
                                                                    mt: planBenefits.length > 1 ? 1 : 0,
                                                                    backgroundColor: '#0065FF', color: '#FFFFFF', minWidth: '36px', height: '36px',
                                                                    borderRadius: '8px', padding: 0, lineHeight: 1,
                                                                    boxShadow: 'none', '&:hover': { backgroundColor: '#0052CC' }
                                                                }}
                                                            >
                                                                +
                                                            </Button>
                                                        )}
                                                    </Grid2>
                                                </Grid2>
                                            ))}
                                        </Grid2>
                                    </Grid>

                                    <Grid item xs={12} sm={12}>
                                        <Label>Subscription T&C</Label>
                                        <TextField  sx={{marginTop:'1%'}}
                                            placeholder="Terms and Conditions" fullWidth variant="outlined" type="text" value={tnc}
                                            onChange={(e) => setTnc(e.target.value)} multiline minRows={4}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF', borderRadius:'8px'}
                                            }}
                                        />
                                        <Grid item container sx={{marginTop:'2px', alignItems:'center', borderRadius:'8px'}}>
                                            <InfoIcon sx={{color:'#2A313C', fontSize:'16px'}} />
                                            <Typography sx={{ color:'#2A313C', fontSize:'14px', marginLeft:'4px'}}>Add your subscription details</Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <div style={{ marginTop: '40px', display: 'flex', justifyContent: 'center', gap: '20px', marginBottom:'40px' }}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleSubmit}
                                        sx={{width: '140px',height: '50px',textTransform: 'none',
                                            fontSize: '16px',backgroundColor: '#0065FF',color: 'white'}}>
                                        {editable ? 'Update' : 'Save'}
                                    </Button>
                                    <Button
                                        variant="contained"
                                        onClick={handleClose}
                                        sx={{
                                            width: '140px',
                                            height: '50px',
                                            textTransform: 'none',
                                            fontSize: '16px',
                                            backgroundColor: '#F0F0F0',
                                            color: '#B0B0B0',
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                </div>
                            </Paper>

                        </div>
                    </Box>
                </div>
            )}

            <Dialog
                open={openCancelConfirmModal}
                onClose={() => setOpenCancelConfirmModal(false)}
                aria-labelledby="cancel-booking-dialog-title"
                aria-describedby="cancel-booking-dialog-description"
                PaperProps={{
                    style: {
                        borderRadius: '12px',
                        padding: '10px'
                    }
                }}
            >
                <DialogTitle id="cancel-booking-dialog-title" sx={{fontWeight:'bold'}}>Confirm Deletion</DialogTitle>
                <DialogContent>
                    <DialogContentText id="cancel-booking-dialog-description">
                        Are you sure you want to delete this subscription plan?
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{paddingBottom:'20px', paddingRight:'20px'}}>
                    <Button 
                        onClick={() => setOpenCancelConfirmModal(false)} 
                        sx={{
                            color: '#6B7280', 
                            borderRadius:'8px', 
                            textTransform:'none',
                            border: '1px solid #D1D5DB',
                            '&:hover': {
                                backgroundColor: '#F3F4F6',
                                borderColor: '#9CA3AF'
                            }
                        }}
                    >
                        No
                    </Button>
                    <Button 
                        onClick={() => {
                            setEnabled(planId,-1);
                        }} 
                        color="error"
                        variant="contained"
                        sx={{ 
                            backgroundColor: '#EF4444', 
                            borderRadius:'8px', 
                            textTransform:'none',
                            '&:hover': {
                                backgroundColor: '#DC2626'
                            }
                        }}
                        autoFocus
                    >
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>

            <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>
        </div>
    )
}

export default DriverSubscription;